import { createClient } from "@supabase/supabase-js";

// Determine environment
const isDevelopment = process.env.REACT_APP_ENV === 'development';

// Select appropriate Supabase configuration based on environment
const supabaseUrl = isDevelopment
	? process.env.REACT_APP_SUPABASE_URL_DEV
	: process.env.REACT_APP_SUPABASE_URL;

const supabaseKey = isDevelopment
	? process.env.REACT_APP_SUPABASE_ANON_KEY_DEV
	: process.env.REACT_APP_SUPABASE_ANON_KEY;

// Fallback to production if dev keys are not set
const finalUrl = supabaseUrl || process.env.REACT_APP_SUPABASE_URL;
const finalKey = supabaseKey || process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(finalUrl, finalKey);

// Log current environment (only in development)
if (process.env.NODE_ENV === 'development') {
	console.log('Supabase Environment:', isDevelopment ? 'Development' : 'Production');
}